/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetKillmailsKillmailIdKillmailHashItem } from './GetKillmailsKillmailIdKillmailHashItem';
import {
    GetKillmailsKillmailIdKillmailHashItemFromJSON,
    GetKillmailsKillmailIdKillmailHashItemFromJSONTyped,
    GetKillmailsKillmailIdKillmailHashItemToJSON,
    GetKillmailsKillmailIdKillmailHashItemToJSONTyped,
} from './GetKillmailsKillmailIdKillmailHashItem';
import type { GetKillmailsKillmailIdKillmailHashPosition } from './GetKillmailsKillmailIdKillmailHashPosition';
import {
    GetKillmailsKillmailIdKillmailHashPositionFromJSON,
    GetKillmailsKillmailIdKillmailHashPositionFromJSONTyped,
    GetKillmailsKillmailIdKillmailHashPositionToJSON,
    GetKillmailsKillmailIdKillmailHashPositionToJSONTyped,
} from './GetKillmailsKillmailIdKillmailHashPosition';

/**
 * victim object
 * @export
 * @interface GetKillmailsKillmailIdKillmailHashVictim
 */
export interface GetKillmailsKillmailIdKillmailHashVictim {
    /**
     * alliance_id integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    allianceId?: number;
    /**
     * character_id integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    characterId?: number;
    /**
     * corporation_id integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    corporationId?: number;
    /**
     * How much total damage was taken by the victim
     * 
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    damageTaken: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    factionId?: number;
    /**
     * items array
     * @type {Array<GetKillmailsKillmailIdKillmailHashItem>}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    items?: Array<GetKillmailsKillmailIdKillmailHashItem>;
    /**
     * 
     * @type {GetKillmailsKillmailIdKillmailHashPosition}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    position?: GetKillmailsKillmailIdKillmailHashPosition;
    /**
     * The ship that the victim was piloting and was destroyed
     * 
     * @type {number}
     * @memberof GetKillmailsKillmailIdKillmailHashVictim
     */
    shipTypeId: number;
}

/**
 * Check if a given object implements the GetKillmailsKillmailIdKillmailHashVictim interface.
 */
export function instanceOfGetKillmailsKillmailIdKillmailHashVictim(value: object): value is GetKillmailsKillmailIdKillmailHashVictim {
    if (!('damageTaken' in value) || value['damageTaken'] === undefined) return false;
    if (!('shipTypeId' in value) || value['shipTypeId'] === undefined) return false;
    return true;
}

export function GetKillmailsKillmailIdKillmailHashVictimFromJSON(json: any): GetKillmailsKillmailIdKillmailHashVictim {
    return GetKillmailsKillmailIdKillmailHashVictimFromJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashVictimFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetKillmailsKillmailIdKillmailHashVictim {
    if (json == null) {
        return json;
    }
    return {
        
        'allianceId': json['alliance_id'] == null ? undefined : json['alliance_id'],
        'characterId': json['character_id'] == null ? undefined : json['character_id'],
        'corporationId': json['corporation_id'] == null ? undefined : json['corporation_id'],
        'damageTaken': json['damage_taken'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetKillmailsKillmailIdKillmailHashItemFromJSON)),
        'position': json['position'] == null ? undefined : GetKillmailsKillmailIdKillmailHashPositionFromJSON(json['position']),
        'shipTypeId': json['ship_type_id'],
    };
}

export function GetKillmailsKillmailIdKillmailHashVictimToJSON(json: any): GetKillmailsKillmailIdKillmailHashVictim {
    return GetKillmailsKillmailIdKillmailHashVictimToJSONTyped(json, false);
}

export function GetKillmailsKillmailIdKillmailHashVictimToJSONTyped(value?: GetKillmailsKillmailIdKillmailHashVictim | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alliance_id': value['allianceId'],
        'character_id': value['characterId'],
        'corporation_id': value['corporationId'],
        'damage_taken': value['damageTaken'],
        'faction_id': value['factionId'],
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetKillmailsKillmailIdKillmailHashItemToJSON)),
        'position': GetKillmailsKillmailIdKillmailHashPositionToJSON(value['position']),
        'ship_type_id': value['shipTypeId'],
    };
}

